import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Proyectos from './pages/Proyectos';
import Tareas from './pages/Tareas';
import Usuarios from './pages/Usuarios';
import Timesheet from './pages/Timesheet';
import Clientes from './pages/Clientes';
import Empresas from './pages/Empresas';
import Navbar from './components/Navbar';
import Suscripcion from './pages/Suscripcion';
import PagoResultado from './pages/PagoResultado';


function Layout({ children }) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar />
      <Box sx={{
        ml: '220px',
        flex: 1,
        minHeight: '100vh',
        backgroundColor: '#F5F7FA'
      }}>
        {children}
      </Box>
    </Box>
  );
}

function RutaProtegida({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <RutaProtegida>
              <Layout><Dashboard /></Layout>
            </RutaProtegida>
          } />
          <Route path="/proyectos" element={
            <RutaProtegida>
              <Layout><Proyectos /></Layout>
            </RutaProtegida>
          } />
          <Route path="/tareas" element={
            <RutaProtegida>
              <Layout><Tareas /></Layout>
            </RutaProtegida>
          } />
          <Route path="/usuarios" element={
            <RutaProtegida>
              <Layout><Usuarios /></Layout>
            </RutaProtegida>
          } />
          <Route path="/timesheet" element={
            <RutaProtegida>
              <Layout><Timesheet /></Layout>
            </RutaProtegida>
          } />
          <Route path="/clientes" element={
            <RutaProtegida>
              <Layout><Clientes /></Layout>
            </RutaProtegida>
          } />
          <Route path="/empresas" element={
            <RutaProtegida>
              <Layout><Empresas /></Layout>
            </RutaProtegida>
          } />
          <Route path="/suscripcion" element={
            <RutaProtegida>
              <Layout><Suscripcion /></Layout>
            </RutaProtegida>
          } />
          <Route path="/pago/resultado" element={
            <RutaProtegida>
             <Layout><PagoResultado /></Layout>
           </RutaProtegida>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;